<ycn-modal-base
    [open]="this.modalOpen"
    (closeModalHandler)="closeModal()">
    <ycn-simple-modal-header
        [header]="'Select Info Fields'"
        [resetModalText]="'Reset'"
        (closeModalHandler)="closeModal()"
        (resetModalHandler)="resetModal()">
    </ycn-simple-modal-header>
    <div class="modal-body">
         <ycn-info-field-list
                [infoType]="infoType"
                [isSingleSelect]="true"
                [modalOpen]="modalOpen"
                [selectedInfoFields]="selectedInfoFields"
                [categories]="categories ?? []"
                [fetchCategories]="fetchCategories ?? true"
                [defaultOnly]="defaultOnly"
                (selectHandler)="selectInfoField($event)">
        </ycn-info-field-list>
    </div>
    <ycn-simple-modal-footer
        [selectedItemCount]="selectedInfoFields.length"
        [disableSubmission]="selectedInfoFields.length === 0"
        (cancelHandler)="closeModal()"
        (submitHandler)="submitInfoFields()">
    </ycn-simple-modal-footer>
</ycn-modal-base>

<ycn-feature-needed></ycn-feature-needed>
